var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0108 6.08332C11.4145 6.08332 12.5525 4.94538 12.5525 3.54166C12.5525 2.13794 11.4145 1 10.0108 1C8.60709 1 7.46915 2.13794 7.46915 3.54166C7.46915 4.94538 8.60709 6.08332 10.0108 6.08332Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.83299 12.6667V10.2503C5.83299 7.94865 7.69833 6.0724 10.0109 6.0724C12.3235 6.0724 14.1888 7.93774 14.1888 10.2503V12.6667",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.79719 6.69267C4.79178 6.69267 5.59805 5.8864 5.59805 4.89181C5.59805 3.89722 4.79178 3.09094 3.79719 3.09094C2.8026 3.09094 1.99632 3.89722 1.99632 4.89181C1.99632 5.8864 2.8026 6.69267 3.79719 6.69267Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.832993 9.33339C0.832993 7.6944 2.15835 6.69281 3.79734 6.69281C4.37402 6.69281 4.92035 6.85469 5.37563 7.14809",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.7791 6.69269C17.7737 6.69269 18.58 5.88641 18.58 4.89182C18.58 3.89723 17.7737 3.09096 16.7791 3.09096C15.7845 3.09096 14.9783 3.89723 14.9783 4.89182C14.9783 5.88641 15.7845 6.69269 16.7791 6.69269Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.6571 9.33339C19.6571 7.6944 18.4184 6.69281 16.7795 6.69281C16.2028 6.69281 15.6564 6.85469 15.2012 7.14809",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.2d41753e9ddd78e9ef88250e36977794.svg";
export { ForwardRef as ReactComponent };